import { render, staticRenderFns } from "./input.message.vue?vue&type=template&id=6f6fa96a"
import script from "./input.message.vue?vue&type=script&lang=js"
export * from "./input.message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports